import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import RichContent from '../../uielements/RichContent/richContent'
import Spacer from '../../uielements/Spacer'
import Button from '../../uielements/Button'
import { useTranslation } from 'react-i18next'
import { screenSizes } from '../../lib/constants'

const LevelWrapper = styled.div`
    display: block;
    position: relative;
    height: 55vh;
    background: '#fff';
`

const Title = styled.div`
    font-size: 2rem;
    font-weight: bold;
    color: ${theme.blue};
`

const TextPart = styled.div`
    width: 50%;
    padding: 30px;
    text-align: center;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    @media (max-width: ${screenSizes.md}px) {
        left: 0;
        width: 100%;
        position: absolute;
        z-index: 1;
    }
`

const TextWrapper = styled.div`
    display: block;
    max-width: 400px;
    margin: 0 auto;
`

const ImagePart = styled.div`
    background-position: center;
    background-image: url('${({ bgImage }) => bgImage}');
    background-size: cover;
    position: absolute;
    top: 0;
    left: 50%;
    right: 0;
    bottom: 0;

    @media (max-width: ${screenSizes.md}px) {
        left: 0;
        opacity: 0.5;
    }
`

const ButtonWrapper = styled.div`
    display: inline-block;
    margin: 0 auto;
`

const Level = (props) => {
    const { i18n, t } = useTranslation()

    return (
        <LevelWrapper>
            <TextPart>
                <TextWrapper>
                    <Title>{props.children}</Title>
                    <Spacer top="2" />
                    <RichContent body={props?.excerpt} locale={i18n.language} />
                </TextWrapper>
                <Spacer top="2" />
                <ButtonWrapper>
                    <Button link={'/edu/' + props.slug} textColor={theme.blue} arrowColor="blue">
                        {t('read-more-no-tone')}
                    </Button>
                </ButtonWrapper>
            </TextPart>
            <ImagePart bgImage={props.bgImage} />
        </LevelWrapper>
    )
}

Level.propTypes = {
    title: PropTypes.string,
    slug: PropTypes.string,
    excerpt: PropTypes.object,
    bgImage: PropTypes.string,
}

Level.defaultProps = {
    title: 'some title',
    slug: 'some-slug',
    bgImage: 'https://via.placeholder.com/1080x1080',
}

export default Level
